// extracted by mini-css-extract-plugin
export default {"wrapper":"src-modules-account-institution-subaccounts-style__wrapper_poszP","subaccountList":"src-modules-account-institution-subaccounts-style__subaccountList_j7OBX"};